var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteToTextChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.73307 13.2803L4.74905 12.4675L4.75652 12.4618C4.96833 12.2923 5.07521 12.2068 5.19445 12.1459C5.30144 12.0913 5.41552 12.0515 5.5332 12.0273C5.66585 12.0001 5.80402 12.0001 6.08138 12.0001H11.8687C12.614 12.0001 12.9871 12.0001 13.272 11.8549C13.5229 11.7271 13.727 11.5229 13.8548 11.272C14 10.9871 14 10.6144 14 9.86915V4.79802C14 4.05274 14 3.67955 13.8548 3.39461C13.727 3.14373 13.5225 2.9399 13.2716 2.81207C12.9864 2.66675 12.6135 2.66675 11.8668 2.66675H4.13347C3.38673 2.66675 3.01308 2.66675 2.72787 2.81207C2.47698 2.9399 2.27315 3.14373 2.14533 3.39461C2 3.67983 2 4.05347 2 4.80021V12.4475C2 13.158 2 13.5131 2.14564 13.6956C2.2723 13.8543 2.46429 13.9466 2.66732 13.9464C2.90077 13.9461 3.17829 13.7241 3.73307 13.2803Z",
    stroke: "#5F488A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteToTextChat);
export default __webpack_public_path__ + "static/media/inviteToTextChat.a54cb4d25787c93c61aab9e91b9607be.svg";
export { ForwardRef as ReactComponent };